import React, { useRef, useEffect,useState } from "react";
import { useSpring, animated } from "react-spring";
import "./modalcustom.css";

import { Errormsg } from "../../components/tostifymsg/Errrormsg";
import { Succesmsg } from "../../components/tostifymsg/Succesmsg";

export const ModalCustom = ({
  modalCustom,
  setModalCustom,
  title = "Modal Title",
  children,
}) => {
  const modalRef = useRef();

  const animation = useSpring({
    config: { duration: 350 },
    opacity: modalCustom ? 1 : 0,
    transform: modalCustom ? `translateY(0%)` : `translateY(-100%)`,
  });

  return (
    <>
      {modalCustom && (
        <div ref={modalRef} className="Background_trade">
          <animated.div style={animation} className={`modal-content`}>
            <div className="trading_wrapper ModalWrapper_trade p-4">
              
              <div className="d-flex w-100 justify-content-between align-self-center align-items-center mb-3 border-bottom pb-2">
                <h4 className="mb-0 pb-0">{title}</h4>

                <button
                  className="btn btn-outline-danger"
                  onClick={() => setModalCustom(false)}
                >
                  ✕
                </button>
              </div>

              <div className="modal-body-content w-100">{children}</div>
            </div>
          </animated.div>
        </div>
      )}
    </>
  );
};